import { ZodSchema, ZodError } from "zod";

function validateByZod(schema: ZodSchema, data: any) {
  try {
    const values = schema.parse(data);
    return values;
  } catch (error) {
    if (error instanceof ZodError) {
      const errorsData = error.issues.reduce(
        (acc, issue) => {
          const path = issue.path.join(".");
          const message = issue.message;
          acc[path] = message;
          return acc;
        },
        {} as Record<string, string>
      );
      return { withErrors: true, data: errorsData };
    } else {
      console.error("Unexpected error:", error);
    }
  }
}
export default validateByZod;
